import CircularProgress from "@material-ui/core/CircularProgress"
import { makeStyles } from "@material-ui/core/styles"
import React from "react"

const Loading = (props) => {
	const classes = useStyles()

	return props.loading ? (
		<CircularProgress
			id="loading"
			className={props.className + " " + classes.progress}
			style={props.style}
			size={props.size}
		/>
	) : null
}

const useStyles = makeStyles((theme) => ({
	progress: {
		position: "relative",
		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(2),
		marginLeft: "50%",
		left: "-20px",
		color: "#20174A",
	},
}))

export default Loading
